'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var Radio = function Radio(_a) {
    var label = _a.label,
        name = _a.name,
        value = _a.value,
        _a$id = _a.id,
        id = _a$id === undefined ? (0, _utils.idGen)('radio') : _a$id,
        onChange = _a.onChange,
        disabled = _a.disabled,
        inputClassName = _a.inputClassName,
        labelClassName = _a.labelClassName,
        radioGroupValue = _a.radioGroupValue,
        children = _a.children,
        checked = _a.checked,
        rest = __rest(_a, ["label", "name", "value", "id", "onChange", "disabled", "inputClassName", "labelClassName", "radioGroupValue", "children", "checked"]);

    var labelContent = label || children || value;
    var inputValue = value !== undefined ? value : labelContent;
    var inputChecked = checked || radioGroupValue === inputValue;
    var handleChange = function handleChange() {
        if (!disabled && !inputChecked) {
            if (onChange) {
                onChange(inputValue);
            }
        }
    };
    return _react2.default.createElement("div", { className: "luna-form__selection" }, _react2.default.createElement("input", Object.assign({ id: id, className: (0, _classnames2.default)('luna-radio', inputClassName), type: "radio", name: name, value: inputValue && (0, _utils.stringify)(inputValue), checked: inputChecked, disabled: disabled, onChange: handleChange }, rest)), _react2.default.createElement("label", { className: (0, _classnames2.default)('luna-label', labelClassName), htmlFor: id }, labelContent));
};
Radio.propTypes = {
    checked: _propTypes2.default.bool,
    label: _propTypes2.default.node.isRequired,
    id: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    name: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object]).isRequired,
    disabled: _propTypes2.default.bool,
    inputClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
    labelClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
    radioGroupValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object]),
    labelContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object]),
    children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object])
};
Radio.defaultProps = {
    checked: false,
    disabled: false,
    inputClassName: '',
    labelClassName: ''
};
exports.default = Radio;
//# sourceMappingURL=Radio.js.map